/*
 * @Description: 各篇内容有效点击量排名
 * @Date: 2024-01-15 14:09:19
 */
import BiTmplDetail_21 from './bi-tmpl-detail-21.vue';
export default BiTmplDetail_21;
